const currency = localStorage.getItem('currency')

export default {
  state: currency ? { currency: currency } : { currency: 'BTC' },
  mutations: {
    setCurrency (state, value) {
      state.currency = value
      localStorage.setItem('currency', value)
    }
  },
  actions: {
    setCurrency ({ commit }, currency) {
      commit('setCurrency', currency)
    }
  },
  getters: {
    currency (state) {
      return state.currency
    }
  }
}
